import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModaleComponent } from 'app/generic/confirm-modal/confirm-modale.component';
import { ModaleComponent } from 'app/generic/modale/modale.component';
import { LocalDataSource } from 'ng2-smart-table';
import { QuestionarioService } from './questionario.service';

@Component({
  selector: 'ngx-questionario',
  templateUrl: './questionario.component.html',
  styleUrls: ['./questionario.component.scss'],
  providers: [QuestionarioService ,ModaleComponent, ConfirmModaleComponent]
})
export class QuestionarioComponent implements OnInit {

  // TABLE SETTINGS
  settings: any;
  settingsDomande: any;

  // TABLE DATA SOURCE
  source: LocalDataSource = new LocalDataSource();
  
  // FORM
  formRicerca: FormGroup;

  // BOOLEAN
  viewDomande: boolean = true;
  
  // VAR
  optionGraph: any;
  arrayDnPercent: any;
  arrayDsPercent: any;
  arrayPncsPercent: any;
  arrayPscnPercent: any;
  arrayAnni: any = [];
  arrayDomande = [/* 
  {
    idDomanda: 1,
    testoDomanda: 'Il carico di studio degli insegnamenti previsti nel periodo di riferimento è risultato accettabile?'
  },
  {
    idDomanda: 2,
    testoDomanda: 'L\'organizzazione complessiva (orario, esami, intermedi e finali) degli insegnamenti previsti nel periodo di riferimento è risultata accettabile?'
  },
  {
    idDomanda: 3,
    testoDomanda: 'L\'orario delle lezioni degli insegnamenti previsti nel periodo di riferimento è stato congegnato in modo tale da consentire una frequenza e una attività di studio individuale adeguate?'
  },
  {
    idDomanda: 4,
    testoDomanda: 'Le aule in cui si sono svolte le lezioni sono risultate adeguate (si vede, si sente, si trova posto)?'
  },
  {
    idDomanda: 5,
    testoDomanda: 'Sono risultate adeguate le aule studio?'
  },
  {
    idDomanda: 6,
    testoDomanda: 'Sono risultate adeguate le biblioteche?'
  },
  {
    idDomanda: 7,
    testoDomanda: 'Sono risultati adeguati i laboratori?'
  },
  {
    idDomanda: 8,
    testoDomanda: 'Sono risultate adeguate le attrezzature per la didattica?'
  },
  {
    idDomanda: 9,
    testoDomanda: 'Sono risultati adeguati i servizi di trasporto pubblico per e dall\'Ateneo?'
  },
  {
    idDomanda: 10,
    testoDomanda: 'Il servizio svolto dalla segreteria studenti è stato soddisfacente?'
  },
  {
    idDomanda: 11,
    testoDomanda: 'Si ritiene complessivamente soddisfatto/a degli insegnamenti?'
  },
  {
    idDomanda: 12,
    testoDomanda: 'Le soluzioni tecnologiche utilizzate per l\'erogazione della didattica a distanza sono di facile utilizzo?'
  },
  {
    idDomanda: 13,
    testoDomanda: 'Ritiene che le metodiche di insegnamento adottate in modalità a distanza siano state nel complesso efficaci per il trasferimento delle conoscenze?'
  },
  {
    idDomanda: 14,
    testoDomanda: 'Si ritiene complessivamente soddisfatto dell’esperienza della didattica a distanza?'
  }, */
  ]

  //TEMP
  arraySource = [
    {
      idDomanda: 1,
      numRisp: 568,
      dn: 596,
      dnPercent: 5.07,
      pncs: 2133,
      pncsPercent: 13.57,
      pscn: 7692,
      pscnPercent: 52.23,
      ds: 4221,
      dsPercent: 28.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 2,
      numRisp: 568,
      dn: 596,
      dnPercent: 14.57,
      pncs: 2133,
      pncsPercent: 4.07,
      pscn: 7692,
      pscnPercent: 32.23,
      ds: 4221,
      dsPercent: 48.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 3,
      numRisp: 568,
      dn: 596,
      dnPercent: 4.07,
      pncs: 2133,
      pncsPercent: 14.57,
      pscn: 7692,
      pscnPercent: 32.23,
      ds: 4221,
      dsPercent: 48.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 4,
      numRisp: 568,
      dn: 596,
      dnPercent: 14.57,
      pncs: 2133,
      pncsPercent: 4.07,
      pscn: 7692,
      pscnPercent: 12.23,
      ds: 4221,
      dsPercent: 68.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 5,
      numRisp: 568,
      dn: 596,
      dnPercent: 4.07,
      pncs: 2133,
      pncsPercent: 14.57,
      pscn: 7692,
      pscnPercent: 32.23,
      ds: 4221,
      dsPercent: 48.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 6,
      numRisp: 568,
      dn: 596,
      dnPercent: 14.57,
      pncs: 2133,
      pncsPercent: 4.07,
      pscn: 7692,
      pscnPercent: 52.23,
      ds: 4221,
      dsPercent: 28.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 7,
      numRisp: 568,
      dn: 596,
      dnPercent: 8.07,
      pncs: 2133,
      pncsPercent: 10.57,
      pscn: 7692,
      pscnPercent: 52.23,
      ds: 4221,
      dsPercent: 28.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 8,
      numRisp: 568,
      dn: 596,
      dnPercent: 4.07,
      pncs: 2133,
      pncsPercent: 14.57,
      pscn: 7692,
      pscnPercent: 22.23,
      ds: 4221,
      dsPercent: 58.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 9,
      numRisp: 568,
      dn: 596,
      dnPercent: 4.07,
      pncs: 2133,
      pncsPercent: 14.57,
      pscn: 7692,
      pscnPercent: 52.23,
      ds: 4221,
      dsPercent: 28.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 10,
      numRisp: 568,
      dn: 596,
      dnPercent: 8.07,
      pncs: 2133,
      pncsPercent: 10.57,
      pscn: 7692,
      pscnPercent: 52.23,
      ds: 4221,
      dsPercent: 28.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 11,
      numRisp: 568,
      dn: 596,
      dnPercent: 14.57,
      pncs: 2133,
      pncsPercent: 4.07,
      pscn: 7692,
      pscnPercent: 12.23,
      ds: 4221,
      dsPercent: 68.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 12,
      numRisp: 568,
      dn: 596,
      dnPercent: 8.07,
      pncs: 2133,
      pncsPercent: 10.57,
      pscn: 7692,
      pscnPercent: 52.23,
      ds: 4221,
      dsPercent: 28.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 13,
      numRisp: 568,
      dn: 596,
      dnPercent: 4.07,
      pncs: 2133,
      pncsPercent: 14.57,
      pscn: 7692,
      pscnPercent: 52.23,
      ds: 4221,
      dsPercent: 28.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
    {
      idDomanda: 14,
      numRisp: 568,
      dn: 596,
      dnPercent: 14.57,
      pncs: 2133,
      pncsPercent: 4.07,
      pscn: 7692,
      pscnPercent: 42.23,
      ds: 4221,
      dsPercent: 38.83,
      mediaDipartimento: 2.96,
      mediaAteneo: 3.06,
    },
  ]
  listaDipa: any;
  listaCds: any;
  yAxisArray: any = [];
  

  constructor(
    private fb: FormBuilder,
    private restService: QuestionarioService,
  ) {

    let ref = this;
    document.getElementById('nb-global-spinner').style.display = 'none';
    ref.loadPage();
    
  }

  ngOnInit(): void {
    let ref = this;
    ref.setupFormRicerca();
    ref.loadTableSettings();
    ref.setupSettingsDomande();
  }

  setupFormRicerca() {
    
    this.formRicerca = this.fb.group(
      {
        annoAccademico: [null],
        studente: ["Frequentanti"],
        dipartimento: ["DIPARTIMENTO DI FARMACIA"],
        cds: ["SCIENZE DEL FARMACO - D1 [88007]"],
      }
    );
  }

  toggleDomande(){
    this.viewDomande = !this.viewDomande
  }
  
  setupSettings() {

    let ref = this;

    this.settings = {
      noDataMessage: "Nessun dato da visualizzare",
      mode: 'external',
      hideSubHeader: true,
      actions: true,
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      pager: {
        display: true,
        perPage: 15
      },
      columns: {
        idDomanda: {
          title: 'DOMANDA',
          type: 'string',
        },
        numRisp: {
          title: 'NUM. RISPOSTE',
          type: 'string',
        },
        dn: {
          title: 'DN',
          type: 'string',
        },
        dnPercent: {
          title: 'DN %',
          type: 'string',
          valuePrepareFunction: (value, row) => {
            return value!=null? value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2}):'-';
          }
        },
        pncs: {
          title: 'PNCS',
          type: 'string',
        },
        pncsPercent: {
          title: 'PNCS %',
          type: 'string',
          valuePrepareFunction: (value, row) => {
            return value!=null? value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2}):'-';
          }
        },
        pscn: {
          title: 'PSCN',
          type: 'string',
        },
        pscnPercent: {
          title: 'PSCN %',
          type: 'string',
          valuePrepareFunction: (value, row) => {
            return value!=null? value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2}):'-';
          }
        },
        ds: {
          title: 'DS',
          type: 'string',
        },
        dsPercent: {
          title: 'DS %',
          type: 'string',
          valuePrepareFunction: (value, row) => {
            return value!=null? value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2}):'-';
          }
        },
        
      },
      attr: {
        class: 'styled-table-1 neutralPrimary'
      }
    };

    if(this.formRicerca.get('cds').value != '*'){
      this.settings.columns.mediaCds = {
        title: 'MEDIA CDS',
        type: 'string',
        valuePrepareFunction: (value, row) => {
          return value!=null? value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2}):'-';
        }
      }
    }

    if(this.formRicerca.get('dipartimento').value != '*'){
      this.settings.columns.mediaDipartimento = {
        title: 'MEDIA DIPARTIMENTO',
        type: 'string',
        valuePrepareFunction: (value, row) => {
          return value!=null? value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2}):'-';
        }
      }
    }

    this.settings.columns.mediaAteneo = {
      title: 'MEDIA ATENEO',
      type: 'string',
      valuePrepareFunction: (value, row) => {
        return value!=null? value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2}):'-';
      }
    }

  }

  preventLetters(ev) {

    if (!(/^([0-9.,])$/.test(ev.key))) {
      ev.preventDefault();
    }

  }

  formatNum(value){
    let actualValue = value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    let valueFormat = parseFloat(actualValue.replace(',','.'));
    return valueFormat;
  }

  loadTableSettings() {

    let annoAccademico = this.formRicerca.get('annoAccademico').value || '*';
    let studente = this.formRicerca.get('studente').value || '*';
    let dipartimento = this.formRicerca.get('dipartimento').value || '*';
    let cds = this.formRicerca.get('cds').value || '*';

    this.setupSettings();
    
    
    this.restService.listAllDataQuestionario(annoAccademico, studente, dipartimento, cds).then(
      res => {
        if(res !=null && res.errorCode == 0){
          // console.log(res);
          let arraySource = [];
          this.yAxisArray = [];
          this.arrayDomande = [];

          let arrayOrdered = res.tQuestionariBindList.sort((a, b) => {return a.domanda-b.domanda});
          arrayOrdered.forEach(el => {
            arraySource.push({
              idDomanda: el.domanda,
              numRisp: el.numRisposte,
              dn: el.dn,
              dnPercent: this.formatNum(el.dnPercentuale),
              pncs: el.pncs,
              pncsPercent: this.formatNum(el.pncsPercentuale),
              pscn: el.pscn,
              pscnPercent: this.formatNum(el.pscnPercentuale),
              ds: el.ds,
              dsPercent: this.formatNum(el.dsPercentuale),
              mediaDipartimento: el.mediaDip,
              mediaCds: el.mediaCds,
              mediaAteneo: el.mediaAteneo
            })

            this.yAxisArray.push(String(el.domanda))

            this.arrayDomande.push({
              idDomanda: el.domanda,
              testoDomanda: el.descrDomanda
            })
          });

          this.source.load(arraySource);
          this.getDataForGraph();
        }
      }
    )

    

  }

  getDataForGraph(){
    this.source.getElements().then(
      el => {
        this.arrayDnPercent = el.map( dn => dn.dnPercent);
        this.arrayDsPercent = el.map( ds => ds.dsPercent);
        this.arrayPncsPercent = el.map( pncs => pncs.pncsPercent);
        this.arrayPscnPercent = el.map( pscn => pscn.pscnPercent);

        this.setupOptionGraph();
      }
    )
  }

  loadPage(){
    this.restService.findAllAnnoAccademico().then(
      res => {
        if(res!=null && res.errorCode==0){
          res.tQuestionariBindList.forEach(el => {
            this.arrayAnni.push({
              annoFormattato1: el.annoAccademico.replace('/','.'),
              annoFormattato2: el.annoAccademico
            });

          });

          this.formRicerca = this.fb.group(
            {
              annoAccademico: [this.arrayAnni[this.arrayAnni.length-1].annoFormattato1],
              studente: ["Frequentanti"],
              dipartimento: ["*"],
              cds: ["*"],
            }
          );

          this.restService.findAllDipartimentiByStudentiAndAnnoAccademico(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value).then(
            res2=>{
              if(res2!=null && res2.errorCode==0){
                this.listaDipa = res2.tQuestionariBindList;
                
              }
            }
          )

          this.restService.findCds(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value, this.formRicerca.get('dipartimento').value).then(
            res3=>{
              if(res3!=null && res3.errorCode==0){
                this.listaCds = res3.tQuestionariBindList;
              }
            }
          )

          this.loadTableSettings();
          this.setupSettingsDomande();
        }
      }
    )
  }

  findDipa(){
    this.formRicerca.get('dipartimento').patchValue('*');
    this.formRicerca.get('cds').patchValue('*');
    this.restService.findAllDipartimentiByStudentiAndAnnoAccademico(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value).then(
      res=>{
        if(res!=null && res.errorCode==0){
          this.listaDipa = res.tQuestionariBindList;
          this.listaCds = [];
        }
      }
    )
  }

  findCds(){
    this.formRicerca.get('cds').patchValue('*');
    this.restService.findCds(this.formRicerca.get('annoAccademico').value, this.formRicerca.get('studente').value, this.formRicerca.get('dipartimento').value).then(
      res3=>{
        if(res3!=null && res3.errorCode==0){
          this.listaCds = res3.tQuestionariBindList;
        }
      }
    )
  }

  setupOptionGraph(){
    const colors = ['#c33', '#f93', '#74b7ff', '#53cb6e'];
    this.optionGraph = {};
    
    this.optionGraph = {
      tooltip: {
        trigger: 'axis',
        formatter: (params) => {
          let row = '';

          params.forEach(el => {
            let valueFormat = el.value.toLocaleString('eu-EU', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            row += `${el.marker} ${el.seriesName}: ${valueFormat}% <br>`
          });
          
          return `<strong>Domanda ${params[0].axisValue}</strong> <br> ${row}`;

        },
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          color: '#000',
          fontSize: 14,
        },
        backgroundColor: '#fff',
      },
      legend: {},
      grid: {
        left: '1%',
        right: '4%',
        bottom: '0',
        height: '90%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          show: true,
          formatter: '{value}%',
        },
        min: 0,
        max: 100,
      },
      yAxis: {
        type: 'category',
        data: this.yAxisArray
      },
      series: [
        {
          name: 'DN',
          type: 'bar',
          stack: 'total',
          label: {
            show: false
          },
          emphasis: {
            focus: 'series'
          },
          data: this.arrayDnPercent,
          color: colors[0]
        },
        {
          name: 'PNCS',
          type: 'bar',
          stack: 'total',
          label: {
            show: false
          },
          emphasis: {
            focus: 'series'
          },
          data: this.arrayPncsPercent,
          color: colors[1]
        },
        {
          name: 'PSCN',
          type: 'bar',
          stack: 'total',
          label: {
            show: false
          },
          emphasis: {
            focus: 'series'
          },
          data:  this.arrayPscnPercent,
          color: colors[2]
        },
        {
          name: 'DS',
          type: 'bar',
          stack: 'total',
          label: {
            show: false
          },
          emphasis: {
            focus: 'series'
          },
          data: this.arrayDsPercent,
          color: colors[3]
        }
      ]
    };
  }

  setupSettingsDomande() {

    let ref = this;

    this.settingsDomande = {
      noDataMessage: "Nessun dato da visualizzare",
      mode: 'external',
      hideSubHeader: true,
      hideHeader: true,
      actions: true,
      pager: {
        display: true,
        perPage: 20
      },
      columns: {
        idDomanda: {
          title: 'DOMANDA',
          type: 'string',
          width: '40px',
          attr: {
            class: 'domandeTable'
          }
        },
        testoDomanda: {
          title: 'NUM. RISPOSTE',
          type: 'string',
          valuePrepareFunction: (value, row) => {
            return value.replaceAll('Ã¨', 'è').replaceAll('Ã', 'à').replaceAll('â€™', '\'');
          }
        },
      },
      attr: {
        class: 'styled-table-1 noButtonNeutral'
      }

    };

  }

}


